import {
  adsCapabilityExploreRequest,
  adsCapabilityRequest,
} from '@web-platform/shared-universal-data-access-frontend/src/network/clients/adsCapability';
import { request as bananaStrevdaSlotsRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/adverts/strevdaGam';
import { strevdaSlotsRequest as acornStrevdaSlotsRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/adverts/strevdaSlots';
import { alternativeDatesRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/alternativeDates';
import { askSkyscannerNudgeRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/askSkyscanner';
import { contentPlatformDistributionSearchRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/content-platform/contentPlatform';
import {
  getExperiences,
  getDolphins,
} from '@web-platform/shared-universal-data-access-frontend/src/network/clients/exploreExperiences/exploreExperiences';
import {
  getIndicativePrices as explorePricingIndicativePricesRequest,
  getMonthlyIndicativePrices as explorePricingMonthlyPricesRequest,
} from '@web-platform/shared-universal-data-access-frontend/src/network/clients/explorePricing/explorePricing';
import { fenryrPriceCalendarExploreRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/fenryr';
import { locationTagsRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/location-tags/locationTags';
import { loyaltyDiscountsRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/loyaltyDiscounts';
import { getPricesForSpan } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/mangalica';
import {
  getHotelCarHire,
  getPackages,
  getPackagesRealTimeSavings,
} from '@web-platform/shared-universal-data-access-frontend/src/network/clients/michelin/michelin';
import { partnerMetadataRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/partnerMetadata';
import { paymentDiscountRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/paymentDiscount';
import { placeholderServiceGetPlaceholdersRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/placeholderService';
import { priceInsightsSearchPriceBandsRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/priceInsights';
import { pricePulseRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/pricePulse';
import { rankExplainabilityRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/rankExplainability';
import { sonarV3PollRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/sonar';
import { sonarV3PollAlphaRequest } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/sonarV3Alpha';
import { terraGetLocationsById } from '@web-platform/shared-universal-data-access-frontend/src/network/clients/terra/terra';
import { http } from '@web-platform/shared-universal-data-access-frontend/src/network/internals/clients/http';
import {
  ADS_CAPABILITY_EXPLORE,
  ALTERNATIVE_DATES_POLL,
  ASK_SKYSCANNER_NUDGE,
  ADS_CAPABILITY_HOMEPAGE,
  EXPLORE_EXPERIENCES,
  EXPLORE_EXPERIENCES_DOLPHINS,
  EXPLORE_PRICING_INDICATIVE_PRICES,
  EXPLORE_PRICING_MONTHLY_PRICES,
  CONTENT_PLATFORM_MEDIA_DISTRIBUTION,
  FENRYR_PRICE_CALENDAR_EXPLORE,
  LOCATION_TAGS_GET,
  LOYALTY_DISCOUNTS,
  MANGALICA_GET_PRICES_FOR_SPAN,
  MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH,
  MICHELIN_GET_HOTEL_CARHIRE_POLLING,
  MICHELIN_GET_PACKAGES,
  MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS,
  PARTNER_METADATA,
  PAYMENT_DISCOUNT,
  PLACEHOLDER_SERVICE,
  PRICE_INSIGHTS_GET_PRICE_BANDS,
  PRICE_PULSE,
  RANK_EXPLAINABILITY,
  SONAR_V3_POLL,
  SONAR_V3_POLL_ALPHA,
  STREVDA_SLOTS,
  TERRA_GET_LOCATIONS_BY_ID,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isAcornRequest } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';

import type { PayloadResponse } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { QueryItem } from '@web-platform/shared-universal-types/src/redux/state/network/queries';

const createMichelinQueryFunction = (
  queryFn: () => Promise<any>,
): (() => Promise<PayloadResponse>) => queryFn;

export function getRequestQueryClient(item: QueryItem): () => Promise<PayloadResponse> {
  if (item.type === ADS_CAPABILITY_EXPLORE) {
    return () => adsCapabilityExploreRequest(item.request);
  }

  if (item.type === SONAR_V3_POLL) {
    return () => sonarV3PollRequest(item.request);
  }

  if (item.type === EXPLORE_EXPERIENCES) {
    return () => getExperiences(item.request);
  }

  if (item.type === EXPLORE_EXPERIENCES_DOLPHINS) {
    return () => getDolphins(item.request);
  }

  if (item.type === EXPLORE_PRICING_INDICATIVE_PRICES) {
    return () => explorePricingIndicativePricesRequest({ body: item.request.body, headers: [] });
  }

  if (item.type === EXPLORE_PRICING_MONTHLY_PRICES) {
    return () => explorePricingMonthlyPricesRequest({ body: item.request.body, headers: [] });
  }

  if (item.type === ASK_SKYSCANNER_NUDGE) {
    return () => askSkyscannerNudgeRequest(item.request);
  }

  if (item.type === LOCATION_TAGS_GET) {
    return () => locationTagsRequest({ body: item.request.body, headers: [] });
  }

  if (item.type === TERRA_GET_LOCATIONS_BY_ID) {
    return () => terraGetLocationsById(item.request);
  }

  if (item.type === LOYALTY_DISCOUNTS) {
    return () => loyaltyDiscountsRequest(item.request);
  }

  if (item.type === MANGALICA_GET_PRICES_FOR_SPAN) {
    return () => getPricesForSpan(item.request);
  }

  if (item.type === PRICE_INSIGHTS_GET_PRICE_BANDS) {
    return () => priceInsightsSearchPriceBandsRequest(item.request);
  }

  if (item.type === PRICE_PULSE) {
    return () => pricePulseRequest(item.request);
  }

  if (
    item.type === MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH ||
    item.type === MICHELIN_GET_HOTEL_CARHIRE_POLLING
  ) {
    return createMichelinQueryFunction(() => getHotelCarHire(item.request));
  }

  if (item.type === MICHELIN_GET_PACKAGES) {
    return createMichelinQueryFunction(() => getPackages(item.request));
  }

  if (item.type === MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS) {
    return createMichelinQueryFunction(() => getPackagesRealTimeSavings(item.request));
  }

  if (item.type === PARTNER_METADATA) {
    return () => partnerMetadataRequest(item.request);
  }

  if (item.type === RANK_EXPLAINABILITY) {
    return () => rankExplainabilityRequest(item.request);
  }

  if (item.type === STREVDA_SLOTS) {
    if (isAcornRequest()) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Promise<{ error: boolean; headers: {}; body:... Remove this comment to see the full error message
      return () => acornStrevdaSlotsRequest(item);
    }
    return () => bananaStrevdaSlotsRequest(item);
  }

  if (item.type === ALTERNATIVE_DATES_POLL) {
    // only for acorn traffic
    return () => alternativeDatesRequest(item.request);
  }

  if (item.type === SONAR_V3_POLL_ALPHA) {
    // only for banana traffic
    return () => sonarV3PollAlphaRequest(item.request);
  }

  if (item.type === FENRYR_PRICE_CALENDAR_EXPLORE) {
    // only for banana traffic
    return () => fenryrPriceCalendarExploreRequest(item.request);
  }

  if (item.type === PAYMENT_DISCOUNT) {
    // only for banana traffic
    return () => paymentDiscountRequest(item.request);
  }

  if (item.type === ADS_CAPABILITY_HOMEPAGE) {
    return () => adsCapabilityRequest(item.request);
  }

  if (item.type === PLACEHOLDER_SERVICE) {
    // only for banana (ExploreAI) traffic
    return () => placeholderServiceGetPlaceholdersRequest(item.request);
  }

  if (item.type === CONTENT_PLATFORM_MEDIA_DISTRIBUTION) {
    // only for banana traffic
    return () => contentPlatformDistributionSearchRequest(item.request);
  }

  return () =>
    http(item.request).then(
      (r) => r,
      (err) => {
        throw err;
      },
    );
}
